import React, { useState } from "react";
import styles from "./SupervisorCentralCommandScreen.module.css";
import { Dropdown, TextComponent } from "../../../components";
import { List, Table } from "antd";
import { BsThreeDots } from "react-icons/bs";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { t } from "i18next";
import TopTabComponent from "../../../../src/components/TopTabComponent/TopTabComponent";
import { Flex, Progress } from "antd";
import filtericon from "../../../assets/images/filter.svg";
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";
import ModalComponent from "../../../components/modal/ModalComponent";
import CheckBox from "../../../components/Checkbox/CheckBox";
import { useNavigate } from "react-router-dom";

const options = [
  { id: 1, name: "Department" },
  { id: 2, name: "Staff Member" },
  { id: 3, name: "Task Status" },
];

const departmentTypes = [
  { id: 1, label: "Mixing", value: "Mixing" },
  { id: 2, label: "MakeUp", value: "Make Up" },
  { id: 3, label: "Proofing", value: "Proofing" },
   { id: 3, label: "Chill", value: "Chill" },
    { id: 3, label: "Oven", value: "Oven" }, 
    { id: 3, label: "Assembly", value: "Assembly" },
     { id: 3, label: "Packaging", value: "Packaging" },
];

  const columns = [
   {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Attendance",
      dataIndex: "Attendance",
      key: "Attendance",
    },
    {
      title: "Total Tasks",
      key: "TotalTasks",
      dataIndex: "TotalTasks",
    },
    {
      title: "Completed Tasks",
      key: "CompletedTasks",
      dataIndex: "CompletedTasks",
    },
    {
      title: "Scheduled Tasks",
      key: "ScheduledTasks",
      dataIndex: "ScheduledTasks",
    },
    {
      title: "In Progress",
      key: "InProgress",
      dataIndex: "InProgress",
    },

  ];

  const data = [
    {
     Name: "Dwight",
      Attendance: "Yes",
      TotalTasks: "06",
      CompletedTasks:"04",
      ScheduledTasks:"02",
      InProgress:"01",
    }, 
      {
     Name: "Dustin",
      Attendance: "No",
      TotalTasks: "04",
      CompletedTasks:"02",
      ScheduledTasks:"02",
      InProgress:"03",
    }, 
     {
     Name: "Cody",
      Attendance: "Yes",
      TotalTasks: "02",
      CompletedTasks:"02",
      ScheduledTasks:"02",
      InProgress:"03",
        
    }, 
      
  ];

const SupervisorCentralCommandScreen = () => {
  const navigate = useNavigate()
  const [Department, setCategory] = useState("Department");
  const [focusedIcon, setFocusedIcon] = useState(null);
  const [department, setdepartment] = useState(departmentTypes[0]);
  const [FilterModal, setFilterModal] = useState(false);

  const [focusedTab, setFocusedTab] = useState(options[0]);

  const OverviewData = [
    {
      Name: 123,
      Product: "Cookies",
      Station: "Mixing",
      StartTime: "11:25 pm",
      OrderStatus: "In Progress",
      color: "#C6450C",
    },
    {
      Name: 233,
      Product: "Cookies",
      Station: "Mixing",
      StartTime: "11:25 pm",
      OrderStatus: "In Progress",
      color: "#F37E43",
    },
    {
      Name: 233,
      Product: "Cookies",
      Station: "Mixing",
      StartTime: "11:25 pm",
      OrderStatus: "In Progress",
      color: "#AB3006",
    },
    {
      Name: 233,
      Product: "Cookies",
      Station: "Mixing",
      StartTime: "11:25 pm",
      OrderStatus: "In Progress",
      color: "#C74D52",
    },
    {
      Name: 233,
      Product: "Cookies",
      Station: "Mixing",
      StartTime: "11:25 pm",
      OrderStatus: "In Progress",
      color: "#822D12",
    },
  ];

  const renderOverview = (item, index) => {
    return (
      <div
        className={styles.rj_listItem}
        style={{
          backgroundColor: item?.color,
        }}
        onClick={() => navigate("/supervisor/RecipeProduction/OngoingTask")}
      >
        <div className={styles.Mini_Row}>
          <TextComponent text={"Task ID"} className={styles.CardText} />
          <TextComponent text={`#${item?.Name}`} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent text={"Product"} className={styles.CardText} />
          <TextComponent text={item?.Product} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent text={"Station"} className={styles.CardText} />
          <TextComponent text={item?.Station} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent
            text={"Start Time"}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
          <TextComponent
            text={item?.StartTime}
            className={styles.CardText}
            fontSize={"var(--mobile-sub-heading)"}
            color={"--var(white-color)"}
            padding={"0px"}
          />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent
            text={"Status"}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
          <TextComponent
            text={item?.OrderStatus}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
        </div>
      </div>
    );
  };

  const Depart = [
    { title: "Mixing", percent: 90 },
    { title: "Baking", percent: 70 },
    { title: "Packaging", percent: 50 },
  ];

  const staff = [
    { title: "James Hall", percent: 90 },
    { title: "Ricky Smith", percent: 70 },
    { title: "Kenneth Allen", percent: 50 },
  ];

  const status = [
    { title: "Active", percent: 90 },
    { title: "Pending", percent: 70 },
    { title: "Complete ", percent: 50 },
  ];

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  return (
    <div className={styles.mainCon}>
      <HeaderComponent
        heading={t("Central Command  Screen ")}
        showControlButtons={false}
        // showFilterIcon={true}
        showBackIcon={false}
        headingStyle={styles.headingStyle}
        // showSearch={true}
        // onClickFilter={() => setFilterModal(true)}
        // onSearch={(e) => console.log(e.target.value)}
        // rightControlsStyle={styles.rightControlsStyle}
      />
      <div className={styles.SubMainCont}>
        <div className={styles.TaskFeedDiv}>
          <TextComponent
            text={t("Live Task Feed ")}
            className={styles.TaskFeedHeading}
          />
          <div>
            <List
              dataSource={OverviewData}
              renderItem={renderOverview}
              style={{ marginTop: 10 }}
              grid={{
                gutter: [0, 16],
                xs: 1,
                sm: 2,
                md: 3,
                lg: 5,
                xl: 5,
                xxl: 5,
              }}
            />
          </div>
        </div>
      </div>
      <div className={styles.filterHead}>
        <TextComponent
          text={t("Workload Distribution Snapshot")}
          className={styles.workloadHead}
        />
        {/* <img src={filtericon} alt="icon" /> */}
        <Dropdown
          value={department}
          className={styles.selectorSelect}
          DropdownContainer={styles.DropdownContainer}
          inputClass={styles.DropDownInnerInput}
          options={departmentTypes}
          onChange={(e) => {
            setdepartment(e);
          }}
        />
      </div>
{/* 
      <div className={styles.tabMainContainer}>
        <TopTabComponent
          options={options}
          focused={focusedTab}
          // setFocused={setFocusedTab}
          TopTabListStyle={styles.TopTabListStyle1}
          TabStyle={styles.TabStyle1}
          // onClick={(option) => setCategory(option.name)}
          setFocused={(option) => {
            setFocusedTab(option);
            setCategory(option.name);
          }}
        />

        {Department === "Department" && (
          <div>
            {Depart.map((st, index) => (
              <div key={index} style={{ marginTop: 20 }}>
                <Flex gap="middle" vertical>
                  <Flex align="center" gap="middle">
                    <span className={styles.prgText}>{st.title}</span>
                    <Progress
                      percent={st.percent}
                      strokeColor="#ab3006"
                      style={{ flex: 1 }}
                    />
                  </Flex>
                </Flex>
              </div>
            ))}
          </div>
        )}

        {Department === "Staff Member" && (
          <div>
            {staff.map((st, index) => (
              <div key={index} style={{ marginTop: 20 }}>
                <Flex gap="middle" vertical>
                  <Flex align="center" gap="middle">
                    <span className={styles.prgText}>{st.title}</span>
                    <Progress
                      percent={st.percent}
                      strokeColor="#ab3006"
                      style={{ flex: 1 }}
                    />
                  </Flex>
                </Flex>
              </div>
            ))}
          </div>
        )}

        {Department === "Task Status" && (
          <div>
            {status.map((st, index) => (
              <div key={index} style={{ marginTop: 20 }}>
                <Flex gap="middle" vertical>
                  <Flex align="center" gap="middle">
                    <span className={styles.prgText}>{st.title}</span>
                    <Progress
                      percent={st.percent}
                      strokeColor="#ab3006"
                      style={{ flex: 1 }}
                    />
                  </Flex>
                </Flex>
              </div>
            ))}
          </div>
        )}
      </div> */}

           {/* Table Section */}
            <div className={styles.subCont}>
              <div className={styles.TableDiv}>
                <Table
                  scroll={{ x: true }}
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  rowKey="No"
                />
              </div>
            </div>

      <ModalComponent
        onCancel={() => setFilterModal(false)}
        onClickOkButton={() => setFilterModal(false)}
        onClickCancelButton={() => setFilterModal(false)}
        title={"Filter "}
        open={FilterModal}
        twoButton
        okBtnTitle={"Apply filter"}
        cancelBtnTitle={"Reset filter"}
      >
        <div className={styles.DepartmentDiv}>
          <TextComponent
            text={"Department"}
            className={styles.DepartmentHead}
          />
          <div>
            <CheckBox onClick={onChange}>Mixing</CheckBox>
            <CheckBox onClick={onChange}>Oven</CheckBox>
            <CheckBox onClick={onChange}>Proof / Chill</CheckBox>
          </div>
        </div>
        <div className={styles.TaskDiv}>
          <TextComponent
            text={"Task Status"}
            className={styles.DepartmentHead}
          />
          <div>
            <CheckBox onClick={onChange}>Active</CheckBox>
            <CheckBox onClick={onChange}>Complete </CheckBox>
            <CheckBox onClick={onChange}>Pending</CheckBox>
          </div>
        </div>
      </ModalComponent>
    </div>
  );
};

export default SupervisorCentralCommandScreen;
